/**
 * Slot meeting deep-link slot id
 * ----
 * React Navigation stringifies a missing `:slotId` path param as the literal
 * `"undefined"` (see reservationless dry-run navigate without slotId). Treat
 * that — and `"null"` — as absent so LiveKit join never runs against a fake id.
 */
export function normalizeSlotMeetingSlotId(
  slotId: string | undefined | null,
): string | undefined {
  if (slotId == null) return undefined;
  const trimmed = String(slotId).trim();
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
    return undefined;
  }
  return trimmed;
}
